import React from 'react';
import UIButton from '@/components/shared/UIButton';
import './TenantActionsSection.scss';

interface TenantActionsSectionProps {
  onSaveAllChanges?: () => void;
  onDiscardChanges?: () => void;
  onRemoveTenant?: () => void;
}

const TenantActionsSection: React.FC<TenantActionsSectionProps> = ({
                                                                     onSaveAllChanges = () => console.log('Save all changes'),
                                                                     onDiscardChanges = () => console.log('Discard changes'),
                                                                     onRemoveTenant = () => console.log('Remove tenant')
                                                                   }) => {
  return (
    <div className="TenantActionsSection">



      <div className="TenantActionsSection__buttons">
        {/*
        <UIButton
          variant="primary"
          size="medium"
          onClick={onSaveAllChanges}
          className="TenantActionsSection__button TenantActionsSection__button--save"
        >
          Save all changes
        </UIButton>

        <UIButton
          variant="primary"
          outline
          size="medium"
          onClick={onDiscardChanges}
          className="TenantActionsSection__button TenantActionsSection__button--discard"
        >
          Discard
        </UIButton>
        */}
        <UIButton
          variant="danger"
          size="medium"
          onClick={onRemoveTenant}
          className="TenantActionsSection__button TenantActionsSection__button--remove"
        >
          Remove tenant
        </UIButton>
      </div>
    </div>
  );
};

export default TenantActionsSection;